import React, { useState, useEffect } from 'react';


const ParameterControls = ({
  tradingDate,
  setTradingDate,
  valuationDate,
  setValuationDate,
  interest,
  setInterest,
  dividendRatio,
  setDividendRatio,
  volatility,
  setVolatility,
  startPrice,
  setStartPrice,
  endPrice,
  setEndPrice,
  }) => {

  const [localInterest, setLocalInterest] = useState(interest * 100);
  const [localDividend, setLocalDividend] = useState(dividendRatio * 100);
  const [localVolatility, setLocalVolatility] = useState('');

  useEffect(() => {
    setLocalVolatility((volatility * 100).toFixed(4));
  }, [volatility]);
  const [localStartPrice, setLocalStartPrice] = useState(startPrice);
  const [localEndPrice, setLocalEndPrice] = useState(endPrice);

  useEffect(() => {
    setLocalInterest((interest * 100).toFixed(2));
  }, [interest]);

  useEffect(() => {
    setLocalDividend((dividendRatio * 100).toFixed(2));
  }, [dividendRatio]);



  useEffect(() => {
    if (typeof startPrice === 'number') {
      setLocalStartPrice(startPrice.toFixed(2));
    }
  }, [startPrice]);

  useEffect(() => {
    if (typeof endPrice === 'number') {
      setLocalEndPrice(endPrice.toFixed(2));
    }
  }, [endPrice]);

  const handleInterestChange = (e) => {
    setLocalInterest(e.target.value);
  };

  const handleInterestBlur = (e) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      setInterest(Math.max(0, value) / 100);
      setLocalInterest(Math.max(0, value).toFixed(2));
    }
  };

  const handleDividendChange = (e) => {
    setLocalDividend(e.target.value);
  };

  const handleDividendBlur = (e) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      setDividendRatio(Math.max(0, value) / 100);
      setLocalDividend(Math.max(0, value).toFixed(2));
    }
  };

  const handleVolatilityChange = (e) => {
    setLocalVolatility(e.target.value);
  };

  const handleVolatilityBlur = (e) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      setVolatility(value / 100);
      setLocalVolatility(value.toFixed(4));
    }
  };

  const handleStartPriceChange = (e) => {
    setLocalStartPrice(e.target.value);
  };

  const handleStartPriceBlur = (e) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      setStartPrice(Math.max(0, value));
      setLocalStartPrice(Math.max(0, value).toFixed(2));
    }
  };

  const handleEndPriceChange = (e) => {
    setLocalEndPrice(e.target.value);
  };

  const handleEndPriceBlur = (e) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      setEndPrice(Math.max(0, value));
      setLocalEndPrice(Math.max(0, value).toFixed(2));
    }
  };

  return (
    <div>
      <div>
        <label htmlFor="tradingDate">Trading Date</label>
        <input
          type="date"
          id="tradingDate"
          value={tradingDate}
          onChange={(e) => setTradingDate(e.target.value)}
          disabled
        />
      </div>
      <div>
        <label htmlFor="valuationDate">Valuation Date</label>
        <input
          type="date"
          id="valuationDate"
          value={valuationDate}
          onChange={(e) => setValuationDate(e.target.value)}
        />
      </div>
      <div>
        <label htmlFor="interest">Interest Rate (%)</label>
        <input
          type="number"
          step="0.01"
          min="0"
          id="interest"
          value={localInterest}
          onChange={handleInterestChange}
          onBlur={handleInterestBlur}
        />
      </div>
      <div>
        <label htmlFor="dividend">Dividend Yield (%)</label>
        <input
          type="number"
          step="0.01"
          min="0"
          id="dividend"
          value={localDividend}
          onChange={handleDividendChange}
          onBlur={handleDividendBlur}
        />
      </div>
      <div>
        <label htmlFor="volatility">Implied Volatility Change (%)</label>
        <input
          type="number"
          step="0.0001"
          id="volatility"
          value={localVolatility}
          onChange={handleVolatilityChange}
          onBlur={handleVolatilityBlur}
        />
      </div>
      <div>
        <label htmlFor="startPrice">Chart Range (From)</label>
        <input
          type="number"
          step="0.01"
          min="0"
          id="startPrice"
          value={localStartPrice}
          onChange={handleStartPriceChange}
          onBlur={handleStartPriceBlur}
        />
      </div>
      <div>
        <label htmlFor="endPrice">Chart Range (To)</label>
        <input
          type="number"
          step="0.01"
          min="0"
          id="endPrice"
          value={localEndPrice}
          onChange={handleEndPriceChange}
          onBlur={handleEndPriceBlur}
        />
      </div>
    </div>
  );
};

export default ParameterControls;
